import React, { forwardRef, useImperativeHandle } from 'react'
import cn from 'classnames'

import error_icon from '@/public/images/ic_error.png'

import st from './index.scss'

/**
 *
 * @param { object } props
 * @param { func } props.validate 接受一个函数，入参是当前的值，返回一个布尔值，表示是否合法
 * @param { boolean } props.validateArea 显示错误的区域是否永远占位(即：不显示也占用空间)
 * @param { string } props.validateErrorMessage 错误提示信息
 * @param { boolean } props.showError 有时候你希望错误一直显示，可以通过这个控制
 * @returns
 */
export default forwardRef(function Input({
    className,
    validate = () => true,
    validateErrorMessage = '输入内容不正确',
    validateArea = true,
    showError,
    value,
    onChange = () => {},
    entry,
    ...props
}, ref) {
    const [error_msg, setValidateErrorMessage] = React.useState(validateErrorMessage)
    const [local_value, setLocalValue] = React.useState(value)
    const [error, changeError] = React.useState(false)

    useImperativeHandle(ref, () => ({
        // 外部调用此方法直接显示错误 如果传入参数 则按参数显示错误信息
        setError: (error) => {
            setValidateErrorMessage(error || validateErrorMessage)
            changeError(true)
        },
    }))

    function handleOnChange(value) {
        changeError(!validate(value))
        setLocalValue(value)
        onChange(value)
    }

    return (
        <div className={{[st['outside']]: entry!='login'}}>
            <div
                className={cn(
                    st['box'],
                    {
                        [st['box-error']]: error
                    },
                    className
                )}
            >
                <input
                    value={typeof value !== 'undefined' ? value : local_value}
                    onChange={(e) => handleOnChange(e.target.value)}
                    {...props}
                />
            </div>
            {error && (
                <div className={cn({
                  [st['error-msg']]: true, [st.margin]: entry=='login'
                })}>
                {(typeof showError !== 'undefined' ? showError : error) ? (
                    <>
                        <img src={error_icon} />
                        {error_msg}
                    </>
                ) : null}
                {validateArea ? <span>&nbsp;</span> : null}
              </div>
            )}
        </div>
    )
})
